import { combineReducers } from 'redux';
import faqs from './faqs';

const miscReducer = combineReducers({
    faqs
});

export default miscReducer;